import { render, staticRenderFns } from "./StopsResume.vue?vue&type=template&id=6f9009b8&scoped=true"
import script from "./StopsResume.vue?vue&type=script&lang=js"
export * from "./StopsResume.vue?vue&type=script&lang=js"
import style0 from "./StopsResume.vue?vue&type=style&index=0&id=6f9009b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9009b8",
  null
  
)

export default component.exports